// @flow

import type { AppState } from 'stores'
import { ActiveMunicipalityPath } from 'components/activeMunicipality/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'

function mapStateToProps ({ activeMunicipality }: AppState) {
  return {
    activeMunicipality
  }
}

const hideIfNoRegularMunicipality = branch(
  ({ activeMunicipality }) => activeMunicipality < 0,
  renderNothing
)

export default connect(mapStateToProps)(
  hideIfNoRegularMunicipality(ActiveMunicipalityPath)
)
